export default "__VITE_ASSET__BIQ95U7o__"